import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html'
})
export class TextareaComponent implements OnInit {
  @Input() input: any;
  @Input() group: FormGroup;
  constructor() { }

  ngOnInit() {
  }

}
